import { createContext, useContext } from 'react';

export type ExportFn = {
  id: string;
  text: string;
  fn: () => void;
};

type WidgetContextState = {
  widgetId: string;
  /**
   * The widget's displayed title from its definition (i18n translation).
   * Used as the export title / filename fallback for pre-built widgets that
   * don't carry a user-set `widgetSettings.title`.
   */
  title?: string;
  /**
   * On-screen header size variant (h3 = large/20px left-aligned, h4 =
   * small/14px centred — see BoardItem). Drives the export title size + align.
   */
  headerVariant?: 'h3' | 'h4' | 'h5';
  exportFns?: ExportFn[];
  setExportFns?: (exportFns: ExportFn[]) => void;
  pendingSettingsOpen?: boolean;
  setPendingSettingsOpen?: (value: boolean) => void;
};

const WidgetContext = createContext<null | WidgetContextState>(null);

export const WidgetContextProvider = WidgetContext.Provider;

export const useWidgetContext = () => {
  return useContext(WidgetContext);
};
